// @flow
import React from 'react';
import moment from 'moment-tz';
import styled from 'styled-components';

import {FullHTMLLink} from 'app/components/general/FullHTMLLink';
import {UserAvatar} from 'app/components/general/avatars';
import ElapsedTime from 'app/components/general/ElapsedTime';

import {getObjectCurrentVersionURL} from 'app/urls';
import {colors} from 'js-libs/sweetcommons/styles';
import {gt} from 'app/utils/i18n';

import type {ReviewType, VersionedReviewableObject} from 'app/review/types';

const StyledContainerFullHTMLLink = styled(FullHTMLLink)`
  display: block;
  flex-grow: 1;
  color: ${colors.textDefault};
`;

type Props<T: VersionedReviewableObject> = {
  review: ReviewType,
  reviewedObject: T,
  userTimezone: string,
};

class ReviewItem<T: VersionedReviewableObject> extends React.Component<
  Props<T>
> {
  render() {
    const {
      userTimezone,
      reviewedObject,
      review: {url, reviewed_by, created_at, version_id},
    } = this.props;
    const reviewer = (
      <span className="font-weight-bold mb-1">
        {reviewed_by != null ? reviewed_by.name : gt('Deleted user')}
      </span>
    );
    const reviewedDate = moment(created_at);

    return (
      <div className="d-flex small clearfix p-2" id={`review-${url}`}>
        <div className="d-flex flex-column mr-2">
          {reviewed_by != null ? (
            <UserAvatar user={reviewed_by} showCard />
          ) : null}
        </div>
        <div>
          <StyledContainerFullHTMLLink
            html_url={getObjectCurrentVersionURL(reviewedObject, version_id)}
          >
            {gt('Reviewed by %s', reviewer)}
          </StyledContainerFullHTMLLink>
          <ElapsedTime
            small={true}
            tooltipPlacement="top"
            className="text-muted font-italic py-1"
            timestamp={reviewedDate.tz(userTimezone)}
          />
        </div>
      </div>
    );
  }
}

export default ReviewItem;
